import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import _ from 'lodash';
import { useAppSelector } from '../../../../infra/hooks';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { fonts, themes } from '../../../themes/themes';
import moment from 'moment';
import './DashboardCalendar.css';
import Loader from '../../../Lottifiers/Loader/Loader';
import { useTranslation } from 'react-i18next';
import ar from 'date-fns/locale/ar-SA';
import { useTranslate } from '../../../../hooks';

const DashboardCalendarPresenterData = (prop) => {
  const { t } = useTranslation();
  const calendar_data = useAppSelector(
    (state) => state.dashboardCalendarSlice.calendar,
  );
  const isLoading = useAppSelector(
    (state) => state.dashboardCalendarSlice.dashboardCalendarLoader,
  );
  const [range, setRange] = useState([]);

  const data_leaves = calendar_data.leaves;
  const data_holidays = calendar_data.holidays;
  const data_absent = calendar_data.absents;
  const data_weekoff = calendar_data.weekOffs;

  const handleChange = (_date) => {
    const getMonth = moment(_date).get('month');
    const getYear = moment(_date).get('year');
    prop.handleCalendarChange(getMonth, getYear);
  };

  useEffect(() => {
    const finalData = [];

    // weekoffs
    if (data_weekoff) {
      _.map(data_weekoff, (d) => {
        let weekoff = {
          startDate: new Date(d?.date),
          endDate: new Date(d?.date),
          key: 'selection3',
          color: themes.greyDefault_500,
        };

        finalData.push(weekoff);
      });
    }

    // leaves
    if (data_leaves) {
      _.map(data_leaves, (d) => {
        const _formatStartDate = d?.start_date.split('T');
        const _formatEndDate = d?.end_date.split('T');

        const _startDate = moment(_formatStartDate[0]).format('YYYY-MM-DD');
        const _endDate = moment(_formatEndDate[0]).format('YYYY-MM-DD');
        let leave = {
          startDate: new Date(_startDate),
          endDate: new Date(_endDate),
          key: 'selection0',
          color: themes.leaveCalender,
        };

        finalData.push(leave);
      });
    }

    // holidays
    if (data_holidays) {
      _.map(data_holidays, (d) => {
        let holiday = {
          startDate: new Date(d?.fromDate),
          endDate: new Date(d?.toDate),
          key: 'selection1',
          color: themes.primary,
        };

        finalData.push(holiday);
      });
    }
    // absents
    if (data_absent) {
      _.map(data_absent, (d) => {
        let absent = {
          startDate: new Date(d?.date),
          endDate: new Date(d?.date),
          key: 'selection2',
          color: themes.absentCalender,
        };

        finalData.push(absent);
      });
    }

    setRange(finalData);
  }, [data_leaves, data_absent, data_holidays]);
  // date state

  const { isRTL } = useTranslate();

  return isLoading ? (
    <div style={{ width: '425px' }}>
      <Loader height={100} width={200} />
    </div>
  ) : (
    <>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <DateRange
          ranges={range}
          direction="horizontal"
          showDateDisplay={false}
          editableDateInputs={false}
          showPreview={false}
          locale={isRTL ? ar : undefined}
          className="dashboard__calendar"
          onShownDateChange={(DateRange) => handleChange(DateRange)}
          onChange={() => console.log('')}
          showMonthAndYearPickers={false}
        />
      </Box>

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '2em',
          paddingRight: '2em',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          style={{
            color: themes.leaveCalender,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {' '}
          {t('Leaves')}
        </Typography>
        <Typography
          style={{
            color: themes.primary,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {t('Holidays')}
        </Typography>
        <Typography
          style={{
            color: themes.defaultError,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {' '}
          {t('Absent')}
        </Typography>
        <Typography
          style={{
            color: themes.greyDefault_500,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {t('WeekOffs')}
        </Typography>
      </Box>
    </>
  );
};

export default DashboardCalendarPresenterData;
